import { windowOpenCentered } from "@itslearning/atlas/frames/windowOpen";

export function openPopup(url) {
    const width = Math.max(window.innerWidth * 0.8, 600);
    const height = Math.max(window.innerHeight * 0.8, 600);

    windowOpenCentered(url, width, height);
}
